import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMessage = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M1.913 1.15a.75.75 0 0 0-1.026.944L3.927 10l-3.04 7.905a.75.75 0 0 0 1.026.945l16.945-8.16a.75.75 0 0 0 .456-.69.75.75 0 0 0-.425-.676zm13.366 8.1L2.966 3.322l2.28 5.928zm-10.033 1.5-2.28 5.926 12.309-5.926z",
		clipRule: "evenodd"
	})
});
export default SvgMessage;
